@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="results">
  <div class="inputRow">
    <input class="searchInput" [disabled]="isBusy()" (keyup.enter)="search()" [(ngModel)]="searchTerm"
      placeholder="Enter a Project Name or Location to Search"/>
    <button matButton="elevated" class="inputButton primary-button" [disabled]="isBusy()" (click)="search()">Search</button>
    <button matButton="elevated" class="inputButton" [disabled]="isBusy()" (click)="createSchedule()">Create Schedule
    </button>
    @if (warningMessage()) {
      <div class="warningMessage">{{ warningMessage() }}</div>
    }
    @if (isBusy()) {
      <mat-progress-spinner mode="indeterminate" class="spinner" diameter="24"></mat-progress-spinner>
    }
    <span class="spacer"></span>
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" [pageSize]="25" [showFirstLastButtons]=true></mat-paginator>
  </div>
  <table mat-table [dataSource]="searchResults" matSort class="paginatedTable bordered-table">
    <ng-container matColumnDef="entityId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="entityId">ID</th>
      <td mat-cell *matCellDef="let record">{{ record.id.entityId }}</td>
    </ng-container>
    <ng-container matColumnDef="projectName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="projectName">Project Name</th>
      <td mat-cell *matCellDef="let record">{{ record.projectName }}</td>
    </ng-container>
    <ng-container matColumnDef="totalUnitQty">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="totalUnitQty">Quantity</th>
      <td mat-cell *matCellDef="let record">{{ record.totalUnitQty }}</td>
    </ng-container>
    <ng-container matColumnDef="locationCity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="locationCity">City</th>
      <td mat-cell *matCellDef="let record">{{ record.locationCity }}</td>
    </ng-container>
    <ng-container matColumnDef="locationState">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="locationState">State</th>
      <td mat-cell *matCellDef="let record">{{ record.locationState }}</td>
    </ng-container>
    <ng-container matColumnDef="locationZip">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="locationZip">Zip</th>
      <td mat-cell *matCellDef="let record">{{ record.locationZip }}</td>
    </ng-container>
    <ng-container matColumnDef="createTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="createTimestamp">Created</th>
      <td mat-cell *matCellDef="let record">{{ record.createTimestamp | date: 'MM/dd/yyyy h:mm aa':'UTC' }}</td>
    </ng-container>
    <ng-container matColumnDef="createUser">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="createUser">Created By</th>
      <td mat-cell *matCellDef="let record">{{ record.createUser }}</td>
    </ng-container>
    <ng-container matColumnDef="updateTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="updateTimestamp">Last Update</th>
      <td mat-cell *matCellDef="let record">{{ record.updateTimestamp | date: 'MM/dd/yyyy h:mm aa':'UTC' }}</td>
    </ng-container>
    <ng-container matColumnDef="updateUser">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="updateUser">Updated By</th>
      <td mat-cell *matCellDef="let record">{{ record.updateUser }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr (click)="rowSelected(row)" class="clickableRow" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
